import ApiClient from '../../../ApiClient';
import Result from '../../../Result';
import AlgonomyApiBase from '../AlgonomyApiBase/AlgonomyApiBase';
import { TopSellingProduct } from '../../types';

import { ReccomendationsService } from './service';

class AlgonomyRecommendations extends AlgonomyApiBase implements ReccomendationsService {
  constructor(protected apiClient: ApiClient) {
    super(apiClient);
  }

  // gets data for top selling carousel
  public async getTopSellings(): Promise<Result<Array<TopSellingProduct>> | undefined> {
    try {
      const topSellingsResults = await this.apiClient.get('/featured-airguns');
      const json = await topSellingsResults.json();
      return new Result(json);
    } catch (error) {
      console.error(`can't get top sellings`, error);
    }
  }
}

export default AlgonomyRecommendations;
